import { makeHome } from 'src/main/factories/pages'

export default makeHome
